import React from "react";
import { Navigate } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import { useAuth } from "../contexts/AuthContext";

export default function AuthRedirect() {
  const { currentUser, userType, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (userType === "admin") {
    return <Navigate to="/admin" replace />;
  }

  if (userType === "loja") {
    return <Navigate to="/loja" replace />;
  }

  if (userType === "partner") {
    return <Navigate to="/dashboard" replace />;
  }

  if (userType === "cliente") {
    return <Navigate to="/cliente" replace />;
  }

  return <Navigate to="/login" replace />;
}